import {
  SwapFormState,
  SwapFormStateReducerAction,
  SwapFormTextFieldNames
} from "../SwapForm.types";
import {initialSwapFormState} from "../context/SwapFormContext.constants";

function swapFormStateReducer(
  state: SwapFormState,
  action: SwapFormStateReducerAction
): SwapFormState {
  let newState = state;

  switch (action.type) {
    case "SET_IS_READY": {
      newState = {
        ...state,
        isReady: action.isReady
      };
      break;
    }

    case "SET_SWAP_FORM_ASSETS": {
      newState = {
        ...state,
        isReady: true
      };

      newState.assetIn.asset = action.assetIn;
      newState.assetOut.asset = action.assetOut;
      break;
    }

    case "SET_AMOUNT": {
      const {name, value} = action;

      if (name === SwapFormTextFieldNames.AssetInAmount) {
        newState = {
          ...state,
          assetIn: {
            ...state.assetIn,
            [name]: value
          },
          assetOut: {
            ...state.assetOut,
            [SwapFormTextFieldNames.AssetOutAmount]: ""
          }
        };
      } else if (name === SwapFormTextFieldNames.AssetOutAmount) {
        newState = {
          ...state,
          assetOut: {
            ...state.assetOut,
            [name]: value
          },
          assetIn: {
            ...state.assetIn,
            [SwapFormTextFieldNames.AssetInAmount]: ""
          }
        };
      }

      break;
    }

    case "SET_QUOTE": {
      newState = {
        ...state,
        quote: action.quote
      };
      break;
    }

    case "RESET_FORM": {
      newState = {
        ...initialSwapFormState,
        isReady: Boolean(action.isReady)
      };
      break;
    }

    case "FLIP_ASSET_ORDER": {
      const currentAssetInState = state.assetIn;
      const currentAssetOutState = state.assetOut;

      newState = {
        ...state,
        quote: null,
        assetIn: {
          "asset-in-amount": currentAssetOutState[SwapFormTextFieldNames.AssetOutAmount],
          asset: currentAssetOutState.asset
        },
        assetOut: {
          "asset-out-amount": currentAssetInState[SwapFormTextFieldNames.AssetInAmount],
          asset: currentAssetInState.asset
        }
      };
      break;
    }

    case "SET_TRANSACTIONS_TO_SIGN":
      newState = {
        ...state,
        txnsToSign: action.txnsToSign
      };
      break;

    default:
      break;
  }

  return newState;
}

export default swapFormStateReducer;

/* eslint
      complexity: "off"
*/
